import { useState } from "react";
import { useAuth } from "../../login/AuthProvider";
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import { backend } from '../../../components/apipath';


function Login() {

    //登入
    const [myform, setMyform] = useState({
        account: "",
        password: "",
    });
    const changeFields = (event) => {
        const id = event.target.id;
        const val = event.target.value;

        setMyform({ ...myform, [id]: val });
    };
    const { setAuth } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        
        // console.log(myform);
        // TODO: 欄位檢查

        fetch(`${backend}join/login`, {
            method: "POST",
            body: JSON.stringify(myform),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((r) => r.json())
            .then((result) => {
                if (result.success) {
                    localStorage.setItem("auth", JSON.stringify(result.data));
                    Swal.fire({
                        imageUrl: '/member_img/logo.svg',
                        confirmButtonColor: '#224040',
                        color:"#224040",
                        text: "登入成功",
                    });
                    setAuth({
                        ...result.data,
                        authorized: true,
                    });
                    const searchParams = new URLSearchParams(window.location.search);
                    const redirect = searchParams.get("redirect");
                    navigate(redirect || "/member");                
                } else if (result.code === 401) {
                    Swal.fire({
                        imageUrl: '/member_img/logo.svg',
                        confirmButtonColor: '#224040',
                        title: '糟糕！',
                        color:"#224040",
                        text: "查無此帳號，請先申請會員",
                    });
                }   else if (result.code === 402) {
                    Swal.fire({
                        imageUrl: '/member_img/logo.svg',
                        confirmButtonColor: '#224040',
                        title: '糟糕！',
                        color:"#224040",
                        text: "密碼錯誤，請填寫正確密碼",
                    });
                } else if (result.code === 403) {
                    Swal.fire({
                        imageUrl: '/member_img/logo.svg',
                        confirmButtonColor: '#224040',
                        title: '帳號已被停用',
                        color: '#224040',
                        text: '請聯絡客服或管理員啟用帳號',
                    });
                } else if (!result.code) {
                    Swal.fire({
                        imageUrl: '/member_img/logo.svg',
                        confirmButtonColor: '#224040',
                        title: '登入失敗',
                        color:"#224040",
                        text: "請稍後再試，或聯絡客服",
                    });
                }
            });
            
    };

    return (
        <>
            <form className="forms_form" onSubmit={handleSubmit}>
                <fieldset className="forms_fieldset">
                    <div className="forms_field">
                    <input type="email" placeholder="Email" className="forms_field-input" id="account" value={myform.account} onChange={changeFields} required autoFocus />
                    </div>
                    <div className="forms_field">
                        <input type="password" placeholder="Password" id="password" name="password" className="forms_field-input" value={myform.password}  onChange={changeFields} required />
                    </div>
                </fieldset>
                <div className="forms_buttons">
                <button
                    type="button"
                    className="forms_buttons-forgot"
                    onClick={() => {
                        Swal.fire({
                        title: '忘記密碼？',
                        text: '請輸入註冊時的 Email',
                        input: 'email',
                        inputPlaceholder: 'email@example.com',
                        confirmButtonText: '送出',
                        showCancelButton: true,
                        cancelButtonText: '取消',
                        confirmButtonColor: '#224040',
                        color: '#224040',
                        imageUrl: '/member_img/logo.svg',
                        }).then(async (result) => {
                        if (result.isConfirmed && result.value) {
                            try {
                            const res = await fetch(`${backend}join/forgot-password`, {
                                method: 'POST',
                                headers: {
                                'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ email: result.value }),
                            });

                            const data = await res.json();

                            if (data.code === "200") {
                                Swal.fire({
                                title: '請查收 Email',
                                text: data.message || "密碼重設說明已寄出",
                                imageUrl: '/member_img/logo.svg',
                                confirmButtonColor: '#224040',
                                color: '#224040',
                                });
                            } else {
                                Swal.fire({
                                title: '錯誤',
                                text: data.message || "找不到該帳號",
                                imageUrl: '/member_img/logo.svg',
                                confirmButtonColor: '#224040',
                                color: '#224040',
                                });
                            }
                            } catch (err) {
                            console.error("忘記密碼錯誤", err);
                            Swal.fire({
                                title: '伺服器錯誤',
                                text: '請稍後再試',
                                imageUrl: '/member_img/logo.svg',
                                confirmButtonColor: '#224040',
                                color: '#224040',
                            });
                            }
                        }
                        });
                    }}
                    >
                    忘記密碼?
                    </button>
                    <input type="submit" value="Log In" className="forms_buttons-action"/>
                </div>
            </form>
        </>
    );
}

export default Login;